import { Box, styled } from '@mui/material';

export const BoxWithHidenScrollBar = styled(Box)({
  overflowX: 'auto',
  '&::-webkit-scrollbar': { display: 'none' },
  width: 'calc(100% + 24px)'
});

export default { BoxWithHidenScrollBar };
